<template>
  <div>
    <div class="">
      <div style="width: 100%;">
        <div class="col-md-12 text-center bg-primary text-white" style="padding: 20px;opacity: 0.8;">
          套餐购买
          <button @click="back()" style="margin-left: 10px;" class="btn btn-secondary btn-sm">返回</button>
        </div>
      </div>
      <div class="container-fluid">
        <div class="col-md-10 mx-auto">
          <!-- <div class="col-md-10 mx-auto" style="padding: 10px;">
            时长选择
          </div> -->
          <div style="margin-top: 10px;">
            <div class="text-primary" style="font-size: 17px;font-weight: 400;">
              时长选择
            </div>
            <div style="display: flex;align-items: center;justify-content: flex-start;padding: 10px 0px 0px 0px;">

              <div style="margin: 0;" @click="timeClick('year')" :class="{'shadow-active':getTimeStyle('year'),'shadow':! getTimeStyle('year'),'time-card':isPc,'time-card-sm':!isPc}">
                <div class="bg-primary text-white time">
                  一年
                </div>
                <div class="price">
                  <span class="text-primary">￥{{fee_list[fee_id-1].year_price}}</span>
                  <span class="text-sm text-warning per-month">约{{parseInt(fee_list[fee_id-1].year_price/12)}}元/月</span>
                </div>
              </div>

              <div @click="timeClick('quarter')" :class="{'shadow-active':getTimeStyle('quarter'),'shadow':! getTimeStyle('quarter'),'time-card':isPc,'time-card-sm':!isPc}">
                <div class="bg-primary text-white time">
                  三个月
                </div>
                <div class="price">
                  <span class="text-primary">￥{{fee_list[fee_id-1].quarter_price}}</span>
                  <span class="text-sm text-warning per-month">约{{parseInt(fee_list[fee_id-1].quarter_price/3)}}元/月</span>
                </div>
              </div>

              <div @click="timeClick('month')" :class="{'shadow-active':getTimeStyle('month'),'shadow':! getTimeStyle('month'),'time-card':isPc,'time-card-sm':!isPc}">
                <div class="bg-primary text-white time">
                  一个月
                </div>
                <div class="price">
                  <span class="text-primary">￥{{fee_list[fee_id-1].month_price}}</span>
                  <span class="text-sm text-warning per-month">约{{parseInt(fee_list[fee_id-1].month_price)}}元/月</span>
                </div>
              </div>

            </div>
          </div>

          <div style="margin-top: 10px;">
            <div class="text-primary" style="font-size: 17px;font-weight: 400;">
              支付方式选择
            </div>
            <div style="display: flex;align-items: center;justify-content: flex-start;padding: 10px 0px 0px 0px;">

              <div style="margin: 0;" @click="methodClick(1)" :class="{'shadow-active':getMethodStyle(1),'shadow':! getMethodStyle(1)}"
                class="time-card">
                <div class="text-white time" style="background-color: #00997a;">
                  <i class="fa fa-wechat text-white" style="font-size: 40px;"></i>
                </div>
                <div class="price">
                  <span class="text-primary text-lg">微信支付</span>
                </div>
              </div>

              <div @click="methodClick(2)" :class="{'shadow-active':getMethodStyle(2),'shadow':! getMethodStyle(2)}"
                class="time-card" style="margin-left: 50px;">
                <div class="text-white time" style="background-color: #55aaff;">
                  <svg t="1595343049238" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="5458" width="200" height="200">
                    <path d="M586.2464 667.62112s-74.24512 59.41504-101.2608 74.98112c-23.7312 13.67168-46.01856 22.77504-65.87264 29.08544-19.85536 6.30784-37.2608 10.27456-52.20864 11.9104-61.26592 8.32128-101.72928 0.8192-124.38784-5.2544-63.79648-16.90368-89.34784-53.84192-99.15904-71.82976-9.80992-17.98528-14.71744-38.89152-14.71744-62.71616 0.46976-20.5568 6.07488-39.24224 16.8192-56.06144 10.74432-16.82176 24.64256-31.07072 41.69856-42.74944 17.05088-11.68128 61.48224-37.14688 119.48032-34.336 20.5568 0.93312 40.41088 3.38304 59.56608 7.35616 39.66208 7.64672 85.74208 23.96672 104.768 32.58496 0 0 55.10784 24.55424 80.93952 32.93568C582.4 545.28 619.52 477.44 629.70112 432.86016H325.5616v-33.6384H469.2224v-77.78176H269.50016v-33.63968h199.71968V224.7296c0-4.20608 4.1664-17.15584 46.94912-17.51936h53.96096v80.59008h205.3248v33.63968h-205.3248v77.78304h163.1616c0.03584-0.23168 0.08192-0.46848 0.11776-0.69888v0.69888h-0.11776c-3.28192 20.81664-8.8448 42.77248-16.69888 65.8752-6.53824 20.0896-16.23296 42.98112-29.0816 68.672-12.84864 25.69344-29.78304 52.09088-50.80576 79.18592 0 0 160.82944 76.92288 330.60352 104.0256C995.50464 654.44096 1011.2 585.05344 1011.2 512c0-275.70176-223.49824-499.2-499.2-499.2C236.29952 12.79872 12.8 236.29952 12.8 512c0 275.70176 223.49952 499.2 499.2 499.2 171.01696 0 321.94176-86.0032 411.90528-217.10976-91.43808-19.89504-188.53888-60.224-337.65888-126.46912z"
                      fill="#FFFFFF" p-id="5459"></path>
                    <path d="M193.81248 645.19296c-1.87392 85.65632 95.04768 92.02048 109.98912 92.47872 49.39008 1.51936 89.28128-17.13664 120.35328-35.58912 31.06304-18.45376 77.00352-61.6896 89.21216-73.0048-13.54624-7.47776-26.8608-14.368-39.94112-20.67584-13.0816-6.30656-79.54048-41.9968-138.52416-48.10496-111.68512-11.56736-140.51968 58.83904-141.08928 84.896z"
                      fill="#FFFFFF" p-id="5460"></path>
                  </svg>
                </div>
                <div class="price">
                  <span class="text-primary text-lg">支付宝</span>
                </div>
              </div>

            </div>
          </div>

          <!-- <div style="margin-top: 50px;">
            <div class="text-primary" style="font-size: 17px;font-weight: 400;">
              支付金额：
              <span class="text-danger" style="font-size: 15px;">10元</span>
            </div>
          </div> -->

          <div style="margin-top: 20px;">
            <div>
              <base-button @click="prePay()" size="lg" type="primary">确定支付</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue';
  import {
    Button,
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Breadcrumb,
    BreadcrumbItem,
    MessageBox,
  } from 'element-ui'
  import {
    FadeTransition,
    CollapseTransition
  } from 'vue2-transitions';
  import User from '@/api/user.js';
  import Vip from '@/api/vip.js';
  import Bus from '@/components/Bus/bus.js'
  import {
    mapState
  } from 'vuex'

  export default {
    components: {
      Button,
      [Breadcrumb.name]: Breadcrumb,
      [BreadcrumbItem.name]: BreadcrumbItem,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [MessageBox.name]: MessageBox,

      FadeTransition,
    },
    data() {
      return {
        select_time: "year",
        select_method: 1,
        fee_id:1,
        fee_list: [{},{},{}],
        paymentInfo:{},
      };
    },
    mounted() {
      //this.getUserInfo();
      Vue.set(this.fee_list,0,this.$route.params.fee_list[0])
      Vue.set(this.fee_list,1,this.$route.params.fee_list[1])
      Vue.set(this.fee_list,2,this.$route.params.fee_list[2])
      this.fee_id=this.$route.params.fee_id;
    },
    methods: {
      getUserInfo() {
        this.$store.commit("showLoading");
        User.getUserInfo().then(res => {
          console.log(res.data);
          this.$store.commit("user/setUserInfo", res.data)
        }).catch(err => {
          this.$msg({
            type: 'error',
            message: err.messages
          });
        }).finally(() => {
          this.$store.commit("hideLoading");
        })
      },
      back() {
        this.$router.push({
          name: 'vipCenter',
          params: {}
        })
      },
      getTimeStyle(time_id) {
        if (this.select_time == time_id) {
          return true;
        }
      },
      timeClick(time_id) {
        this.select_time = time_id;
      },
      getMethodStyle(method_id) {
        if (this.select_method == method_id) {
          return true;
        }
      },
      methodClick(method_id) {
        this.select_method = method_id;
      },
      prePay(){
        this.$store.commit("showLoading");
        Vip.prePay(this.fee_id,this.select_time).then(res => {
        	this.paymentInfo=res;
        	console.log(res);
          this.$msgbox.confirm((res.messages=='价格'?"价格：":"折算后价格：")+res.data.price+"元，点击确定开始支付", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.$store.commit("showLoading");
            Vip.getOrderInfo(this.fee_id,this.select_time).then(res => {
              let payType=(this.select_method==1?"wepay":"alipay");
              let orderId=res.data.id;
              console.log(`${this.apiDomain}/pay/${payType}/${orderId}`);
              if(this.isPc){
                if(payType=="alipay"){
                  this.$msgbox.alert(`请点击按钮支付<a href="${this.apiDomain}/pay/${payType}/${orderId}" target="_blank" class="btn btn-primary">点击支付</a>`, '请点击按钮支付', {
                    dangerouslyUseHTMLString: true
                  });
                }else{
                  this.$msgbox.alert(`请扫码支付<img src="${this.apiDomain}/pay/${payType}/${orderId}">`, '请扫码支付', {
                    dangerouslyUseHTMLString: true
                  });
                }
              }else{
                if(payType=="alipay"){
                  this.$msgbox.alert(`请点击按钮支付<a href="${this.apiDomain}/app-pay/${payType}/${orderId}" target="_blank" class="btn btn-primary">点击支付</a>`, '请点击按钮支付', {
                    dangerouslyUseHTMLString: true
                  });
                }else{
                  this.$msgbox.alert(`请点击按钮支付<a href="${this.apiDomain}/app-pay/${payType}/${orderId}" target="_blank" class="btn btn-primary">点击支付</a>`, '请点击按钮支付', {
                    dangerouslyUseHTMLString: true
                  });
                }
              }
              
            }).catch(err => {
            	this.$msg({
            	  type: 'error',
            	  message: err.messages
            	});
            }).finally(() => {
            	this.$store.commit("hideLoading");
            })
          }).catch(() => {
            this.$msg({
              type: 'info',
              message: '已取消支付'
            });
          });
        }).catch(err => {
        	this.$msg({
        	  type: 'error',
        	  message: err.messages
        	});
        }).finally(() => {
        	this.$store.commit("hideLoading");
        })
      },
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
      }),

    },
  }
</script>
<style scoped="scoped">
  div.el-table .el-table__row:hover {
    background-color: #edfaff;
  }

  .el-breadcrumb__inner {
    font-size: 10px;
  }

  .el-breadcrumb {
    width: 100%;
    display: flex;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
  }

  .sharelist {
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .info {
    max-width: 360px;
    margin: 0 auto;
    padding: 1.5rem;
    text-align: center;
    border-radius: .25rem;
    transition: all .5s;
  }

  .info .info-title {
    margin: 25px 0 15px;
    padding: 0 15px;
    font-weight: 400;
  }

  .shadow {
    transform: scale(0.8);
    box-shadow: 0 15px 35px rgba(50, 50, 93, .1), 0 3px 3px rgba(0, 0, 0, .07) !important;
  }

  .shadow-active {
    box-shadow: 0 15px 35px rgba(50, 50, 93, .1), 0 15px 15px rgba(0, 0, 0, .1) !important;
  }

  .time-card {
    background-color: #fff;
    width: 120px;
    height: 180px;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-shrink: 0;

    border-radius: 10px;
    overflow: hidden;
    margin-left: 50px;
    /* flex-shrink: 0; */
  }

  .time-card:hover {
    transform: scale(1);
    transition: all .3s cubic-bezier(.2, 1, .22, 1);
    -webkit-transition: all .3s cubic-bezier(.2, 1, .22, 1);
    cursor:pointer;
  }

  .time-card>.time {
    width: 250px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .time-card>.price {
    padding: 40px 20px 40px 20px;
    display: flex;
    flex-direction: column;
    font-size: 20px;
  }

  .time-card>.price>.per-month {
    padding-left: 5px;
  }

  .time-card-sm{
    background-color: #fff;
    width: 100px;
    height: 150px;
    display: flex;
    align-items: center;
    flex-direction: column;

    border-radius: 10px;
    overflow: hidden;
    /* flex-shrink: 0; */
  }

  .time-card-sm:hover {
    transform: scale(1);
    transition: all .3s cubic-bezier(.2, 1, .22, 1);
    -webkit-transition: all .3s cubic-bezier(.2, 1, .22, 1);
    cursor:pointer;
  }

  .time-card-sm>.time {
    width: 250px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .time-card-sm>.price {
    padding: 20px 20px 20px 20px;
    display: flex;
    flex-direction: column;
  }

  .time-card-sm>.price>.per-month {
    padding-left: 5px;
    display: none;
  }
</style>
